// Featured scrolls specific behavior

import Vue from "vue";
import $ from "jquery";
import "../../common/image-viewer/image-viewer.js";

/* global window */

//Variables for the scroll behavior of the sidenav
const offset = 30;
const scrollTime = 500;
const sidenavVerticalMargin = 28;
var featuredScrollsBottomMargin = 70;

//On page load
$(() => {

  // Init content pane Vue to hold image viewer components
  new Vue({
    el: "#js-featured-scrolls__content"
  });

  new Vue({
    el: "#sidenav",

    data: {
      activeElement: 0,
      scrollElementTops: []
    },

    methods: {
      handleScroll () {
        var windowTop = $(window).scrollTop();

        //Mark the sidenav element currently scrolled to
        for(var i=0; i<this.scrollElementTops.length; i++) {
          if(windowTop < this.scrollElementTops[i]) {
            this.activeElement = i;
            break;
          }
        }
      }
    },

    created() {
      window.addEventListener("scroll", this.handleScroll);

      //add the tops of the scroll elements to the vue element's data
      for(var i=0; i<window.scrollElementNames.length; i++) {
        this.scrollElementTops[i] = $(".c-featured-scrolls__"+window.scrollElementNames[i]).offset().top;
      }
    },

    destroyed() {
      window.removeEventListener("scroll", this.handleScroll);
    }
  });

    //Set up the sidenav links
    for(var i=0; i< window.scrollElementNames.length; i++) {
        setupLink(window.scrollElementNames[i]);
    }

    //Setup sticky behavior of the sidenav
    setupStickySidenav();
});

//Add anchor locations to the sidenav links
function setupLink(scrollName) {
    var sidenavLink = $(".c-featured-scrolls-sidenav__"+scrollName);
    var anchor = $(".c-featured-scrolls__"+scrollName);

    sidenavLink.on("click", ()=> {
        $("html, body").animate({
            scrollTop: (anchor.offset().top) - offset
        }, scrollTime);
    });
}

//Add stickiness to the sidenav
function setupStickySidenav() {
    var sideNav = $(".c-sidenav");

    //Find the top point where the sidenav becomes sticky
    var sidenavTop = sideNav.offset().top - sidenavVerticalMargin;

    //Find the point where the sidenav sticks to the bottom
    var pageContentBottom = $(".c-page__content")[0].getBoundingClientRect().bottom;
    var bottomLimit = pageContentBottom - sideNav.height() - sidenavVerticalMargin - featuredScrollsBottomMargin;

    $(window).scroll(() => {
        stickySidenav(sideNav, sidenavTop, bottomLimit);
    });

    $(window).resize(() => {
        stickySidenav(sideNav, sidenavTop, bottomLimit);
    });
}

//Change state of the sidenav - stuck to top, fixed during scroll, or stuck to bottom
function stickySidenav(sideNav, sidenavTop, bottomLimit) {
    var windowTop = $(window).scrollTop();

    if (sidenavTop < windowTop) {
      sideNav.addClass("c-sidenav__sticky");
    }
    else {
      sideNav.removeClass("c-sidenav__sticky");
    }

    if(windowTop > bottomLimit) {
      sideNav.removeClass("c-sidenav__sticky");
      sideNav.addClass("c-sidenav__sticky--bottom");
    }
    else {
      sideNav.removeClass("c-sidenav__sticky--bottom");
    }
}




// WEBPACK FOOTER //
// ./src/frontend/pages/featured-scrolls/featured-scrolls.js